export const getPriceRepresntValue = (value: number | string): string =>
  `$${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;

export const getPercentage = (value: number, min: number, max: number): number => ((value - min) / (max - min)) * 100;

export const getClosestThousandValue = (value: string): number => Math.round(Number(value) / 1000) * 1000;
